import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useSpaceGroupsContext } from "@circle-react/contexts/spaceGroupsContext";
import { useWatch } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import { isLegacyAccessSystemAvailable } from "@/react/helpers/accessGroups/accessGroupHelpers";

import type { SpaceFormValues } from "../../types";
import { AutoAddMembersField } from "../fields/AutoAddMembersField";
import { EventAutoRsvpField } from "../fields/EventAutoRsvpField";
import { NameField } from "../fields/NameField";
import { SpaceGroupField } from "../fields/SpaceGroupField";
import { ThumbnailImageField } from "../fields/ThumbnailImageField";
import { SectionShell } from "../SectionShell";

interface GeneralSectionProps {
  currentSpaceGroupId?: number;
  onImageProcessing?: (isProcessing: boolean) => void;
}

export const GeneralSection = ({
  currentSpaceGroupId,
  onImageProcessing,
}: GeneralSectionProps) => {
  const { currentCommunity, currentCommunitySettings } = usePunditUserContext();
  const {
    helpers: { findBy },
  } = useSpaceGroupsContext();
  const currentSpaceGroup = findBy({ id: currentSpaceGroupId });
  const postType = useWatch<SpaceFormValues, "post_type">({
    name: "post_type",
  });

  return (
    <SectionShell title={t("spaces.form.create.sections.general")}>
      <NameField />
      <SpaceGroupField />
      {postType === "course" && onImageProcessing && (
        <ThumbnailImageField onProcessing={onImageProcessing} />
      )}
      <EventAutoRsvpField postType={postType} />
      {isLegacyAccessSystemAvailable(currentCommunitySettings) && (
        <AutoAddMembersField
          spaceGroupMemberCount={
            currentSpaceGroup?.space_group_members_count ?? 0
          }
          chatSpaceMemberLimit={currentCommunity?.chat_space_members_limit ?? 0}
        />
      )}
    </SectionShell>
  );
};
